import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(() => ({
  cancelTypographyButton: {
    fontWeight: 700,
    marginTop: '5%',
    fontFamily: 'Raleway',
    color: '#263057',
    textTransform: 'capitalize',
    fontSize: '16px',
    '&:hover': {
      color: '#1BF57F'
    },
    fontStyle: 'normal',
    lineHeight: '23px'
  },
  typography: {
    mt: 2,
    marginTop: '5%',
    fontFamily: 'Roboto',
    color: '#263057'
  },
  dialogTypography: {
    mt: 2,
    marginTop: '5%',
    fontFamily: 'Roboto',
    color: '#263057'
  },
  confirmTypographyButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    marginBottom: '0.5%',
    backgroundColor: '#00A88F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: '0.05em',
    lineHeight: '21px'
  },
  buttons: {
    position: 'absolute',
    bottom: 18,
    display: 'flex',
    marginLeft: '40%',
    flexDirection: 'row-reverse'
  },
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#00A88F',
    cursor: 'pointer',
    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#1BF57F'
    }
  },
  confirmButtonDisabled: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#BDBEBF',
    // boxShadow: '0px 0px 1px 0px rgba(0,0,0,0.50)',
    // WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    // MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  confirmButtonTypography: {
    color: '#FFFFFF',
    fontSize: 14,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: '0.05em',
    lineHeight: '21px'
  },
  closeButton: {
    width: 90,
    height: 35,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButtonColor: {
    color: '#263057',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    },
    fontWeight: 700,
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    lineHeight: '23px'
  },
  buttonsearch: {
    height: '30px',
    width: '175px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f2f2f2',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#fff'
    },
    border: '2px solid #028B7E',
    borderRadius: '23px'
  },
  searchIconButton: {
    fontSize: '1.5em',
    paddingLeft: 5,
    color: '#028B7E'
  },
  typographyButton: {
    paddingLeft: 5,
    fontFamily: 'Raleway',
    fontSize: 14.5,
    letterSpacing: '0.05em',
    color: '#028B7E'
  }
}))

export default useStyles
